// Matches TextSession.SessionType names on the backend
export const SESSION_TYPE_LABELS = {
  sms: 'SMS',
  convey: 'Convey',
  rcs: 'RCS',
  sms_admin: 'SMS Admin',
  tcapi: 'TT911',
  interagency: 'Interagency',
} as const;

// convey is deprecated — exclude it from the filter UI
export const SESSION_TYPES = Object.entries(SESSION_TYPE_LABELS)
  .filter(([value]) => value !== 'convey')
  .map(([value, label]) => ({ value, label }));
